module.exports = __webpack_public_path__ + "static/image/history/pc/201012@3x.ver2_0_2.jpg?f3f28993";